<template>
  <div class="container">
    <Row>
      <Row type="flex" align="middle" class="menu">
        <Col class="title">数据概览</Col>
        <Col style="margin: 0 20px">·</Col>
        <Col>今日数据</Col>
      </Row>
      <Row type="flex" align="middle">
        <Select multiple v-model="todayJobIds" @on-change="getToday" style="width: 400px; margin: 20px 0" placeholder="请选择岗位">
          <Option v-for="item in jobs" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
        <!-- <Row type="flex" align="middle" style="margin: 0 0 0 20px">
          岗位：
          <Tag type="border" v-for="item in count" :key="item" :name="item" closable @on-close="changePosition">标签{{ item + 1 }}</Tag>
        </Row> -->
      </Row>
      <Row type="flex" align="middle">
        <Col class="card" v-for="(item, index) in cardList" :key="index">
          <img :src="item.img" mode="scaleToFill" class="img" />
          <div class="content" :style="{ color: item.color }">
            <div>{{ item.title }}</div>
            <div class="num">{{ item.num }}</div>
          </div>
        </Col>
      </Row>
    </Row>

    <Row style="margin: 60px 0 0">
      <Row type="flex" align="middle" class="menu">
        <Col class="title">近期趋势</Col>
        <Col style="margin: 0 20px">·</Col>
        <Col>岗位浏览量</Col>
      </Row>
      <Row type="flex" align="middle">
        <Select v-model="dailyJobIds" @on-change="getDaily" multiple style="width: 400px; margin: 20px 0" placeholder="请选择岗位">
          <Option v-for="item in jobs" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
        <!-- <Row type="flex" align="middle" style="margin: 0 0 0 20px">
          岗位：
          <Tag type="border" v-for="item in count" :key="item" :name="item" closable @on-close="changePosition">标签{{ item + 1 }}</Tag>
        </Row> -->
      </Row>
      <Row type="flex" justify="end">
        <Col>
          <DatePicker
            :value="[startTime, endTime]"
            :options="options"
            @on-change="dateChange"
            @input="dateChangeInput"
            type="daterange"
            format="yyyy-MM-dd"
            placeholder="开始时间-结束时间"
            style="width: 300px"
          />
        </Col>
      </Row>
      <Row>
        <div id="main" style="width: 90vw; height: 500px"></div>
      </Row>
    </Row>
  </div>
</template>

<script>
import echarts from 'echarts';

export default {
  data() {
    return {
      startTime: null,
      endTime: null,
      start: '',
      end: '',
      jobs: [],
      dailyJobIds: [],
      myChart: null,
      today: {
        companyResumeCount: 0,
        interviewCount: 0,
        jobView: 0,
        resumeView: 0,
        sayHiCount: 0
      },
      todayJobIds: [],
      options: {
        shortcuts: [
          {
            text: '近7天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: '近30天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          }
        ],
        disabledDate: time => {
          let now = new Date();
          if (time.getTime() > now.getTime()) {
            return true;
          }
          return false;
        }
      },

      chartOption: {
        legend: {},
        tooltip: {
          trigger: 'item'
        },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: [
          {
            type: 'line',
            name: 'Uv',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' },
            data: []
          },
          {
            type: 'line',
            name: 'Pv',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' },
            data: []
          }
        ]
      },

      cardList: [
        {
          title: '岗位浏览',
          num: 0,
          img: require('@/assets/images/gangweiliulan.png'),
          color: '#3727a4'
        },
        {
          title: '简历浏览',
          num: 0,
          img: require('@/assets/images/jianliliulan.png'),
          color: '#098683'
        },
        {
          title: '简历投递',
          num: 0,
          img: require('@/assets/images/jianlitoudi.png'),
          color: '#079e61'
        },
        {
          title: '打招呼',
          num: 0,
          img: require('@/assets/images/dazhaohu.png'),
          color: '#0966a1'
        },
        {
          title: '邀请面试',
          num: 0,
          img: require('@/assets/images/yaoqingmianshi.png'),
          color: '#840e9a'
        }
      ],
      statusList: ['近7天', '近30天'],
      statusIdx: 0
    };
  },

  mounted() {
    this.initEchart();
    let end = new Date();
    let start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.startTime = start;
    this.endTime = end;
    this.getToday();
    this.getDaily();
    this.getJobs();
  },
  methods: {
    setOption(data) {
      let option = Object.assign({}, this.chartOption);
      option.xAxis.data = [];
      option.series[0].data = [];
      option.series[1].data = [];
      data.forEach(item => {
        option.xAxis.data.push(item.date);
        option.series[0].data.push(item.uv);
        option.series[1].data.push(item.pv);
      });
      console.log(option);
      this.myChart.setOption(option);
    },
    getJobs() {
      this.$axios
        .request({
          url: 'front/v1/job',
          params: {
            pageSize: 100,
            idOrder: 'desc'
          }
        })
        .then(res => {
          this.jobs = res.data.list;
        });
    },
    getToday() {
      this.$axios
        .request({
          url: 'front/v1/job-stat/company/today',
          method: 'POST',
          data: { jobIds: this.todayJobIds }
        })
        .then(res => {
          this.today = res.data;
          this.cardList[0].num = this.today.jobView;
          this.cardList[1].num = this.today.resumeView;
          this.cardList[2].num = this.today.companyResumeCount;
          this.cardList[3].num = this.today.sayHiCount;
          this.cardList[4].num = this.today.interviewCount;
        });
    },
    getDaily() {
      this.$axios
        .request({
          url: 'front/v1/job-stat/company/daily',
          method: 'POST',
          data: { jobIds: this.dailyJobIds, startTime: this.start, endTime: this.end }
        })
        .then(res => {
          this.setOption(res.data);
        });
    },
    changePosition(event, name) {
      const index = this.count.indexOf(name);
      this.count.splice(index, 1);
    },
    dateChangeInput(e){
      this.startTime = e[0]
      this.endTime = e[1]
    },
    dateChange(e1) {
      this.start = e1[0];
      this.end = e1[1];
      this.getDaily();
    },
    initEchart() {
      var myChart = echarts.init(document.getElementById('main'));

      window.addEventListener('resize', () => {
        myChart.resize();
      });
      this.myChart = myChart;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
  .menu {
    font-size: 20px;
    color: #333333;
    font-weight: normal;
    .title {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 2px;
        bottom: 2px;
        left: -10px;
        width: 3px;
        background: #ffa4a2;
      }
    }
  }
  .card {
    margin: 0 60px 0 0;
    .img {
      width: 177px;
      height: 95px;
    }
    .content {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 20px;
      line-height: 20px;
      .num {
        font-weight: bold;
        margin: 10px 0 0;
        font-size: 28px;
      }
    }
  }
}

.legend {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .line {
    display: inline-block;
    width: 25px;
    height: 3px;
    background: rgba(126, 72, 199, 1);
    margin-right: 8px;
  }
  .line2 {
    background: rgba(253, 72, 93, 1);
  }
}
</style>
